<template>
  <v-navigation-drawer app clipped mini-variant>
    <v-list>
      <v-list-tile
          v-for="item in items"
          :key="item.title"
          :to="{name: item.route}"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    props: {
      event: {
        type: Object,
        default: function () {
          return {
            'title': 'Eventname'
          }
        }
      }
    },
    data: () => ({
      items: [
        { title: 'Home', icon: 'fal fa-home', route: 'home' },
        { title: 'Teilnehmer', icon: 'fal fa-users', route: 'participants' },
        { title: 'Kategorien', icon: 'fal fa-clipboard-list-check', route: 'categories' },
        { title: 'Versorgungspunkte', icon: 'fal fa-check-double', route: 'checkpoints'}
      ]
    })
  }
</script>

<style>

</style>
